var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#F9F9F9",
    transform: "translate(-547.000000, -256.000000) translate(144.000000, 249.212121) translate(403.709214, 7.393939)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#495171",
    d: "M8.842 7.294l2.757 2.585c.152.14.285.292.4.45.078-.105.163-.208.256-.306l.146-.144 2.757-2.585c.421-.391 1.104-.392 1.525-.002.39.36.42.927.092 1.32l-.09.094-2.758 2.586c-.39.36-.42.929-.09 1.321l.089.094 2.759 2.587c.42.39.42 1.024-.002 1.414-.21.195-.486.292-.761.292-.23 0-.461-.068-.653-.204l-.11-.09-2.76-2.585c-.15-.141-.284-.292-.4-.451-.114.159-.247.31-.399.45l-2.758 2.586c-.21.196-.487.294-.764.294-.275 0-.55-.097-.761-.292-.422-.39-.423-1.023-.002-1.414l2.76-2.587c.42-.39.42-1.024-.002-1.415L7.315 8.706c-.42-.39-.42-1.024.002-1.414.421-.39 1.104-.39 1.525.002z",
    transform: "translate(-547.000000, -256.000000) translate(144.000000, 249.212121) translate(403.709214, 7.393939)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.87076bf31db78dbad95a1ddbcad68962.svg";
export { ForwardRef as ReactComponent };